import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheCountdownBegins from "./sections/TheCountdownBegins";
import TwentyYearsInTheMaking from "./sections/TwentyYearsInTheMaking";
import MemoryLanePhotoWall from "./sections/MemoryLanePhotoWall";
import SecureYourSpot from "./sections/SecureYourSpot";
import VoicesFromTheClass from "./sections/VoicesFromTheClass";
import ReunionCommittee from "./sections/ReunionCommittee";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheCountdownBegins />
      <TwentyYearsInTheMaking />
      <MemoryLanePhotoWall />
      <SecureYourSpot />
      <VoicesFromTheClass />
      <ReunionCommittee />
      <Footer />
    </div>;
}